// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e30c105a","187":"51be3053","538":"b0687c0e","666":"83d405b0","746":"02e7bc23"}[chunkId] + ".chunk.js";
};